export type PhoneZoneCategory = "france" | "europe" | "world";

export const phoneZoneCetagoriesLabels: Record<PhoneZoneCategory, string> = {
    france: "France",
    europe: "Europe",
    world: "World",
};

export const phoneZoneCategories = ["france", "europe", "world"] as const;

export type PhoneZone = {
    prefix: number;
    label: string;
    emoji: string;
    mask: string;
    category: PhoneZoneCategory;
};
